import { ICardContractsProgramListener } from './types'

import { getInputButton } from '@primitive/getInputButton'
import { DictSelectorContainer } from '@smart/dictSelector'

import { Flex, Modal, Input, Button, Container } from '@ui/index'
import { IconClearClose} from '@img/icons'


/** Редактирование свойств слушателя по договору */
export const CardContractProgramListener = ({ isOpen, isAttestationTypeVisible, 
    fieldsError, txtAttestationType, txtQualification, txtAttestationTypeID,
    handleBtnSave, handlerButtonCancel,
}: ICardContractsProgramListener) => {
    return <>
        <Modal isOpen={isOpen} isEsc onCancel={handlerButtonCancel} overflowY="hidden" maxWidth="400px">
            <Flex className='modal_container'>
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                    <h4>Свойства слушателя</h4>

                    <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Container padding='4px'>
                    <Flex gap='15px' className='modal_container-content'>
                        <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                            <Flex flexGrow={1} flexBasis='250px' isRendered={isAttestationTypeVisible} className={!fieldsError.value.attestationType ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Тип аттестации <p className='pulse'></p></Flex>

                                <Input placeholder="Тип аттестации" isReadOnly {...txtAttestationType}
                                    suffix={
                                        <DictSelectorContainer isScroll={false} isSearch={false} dictName="attestationType" onSelect={(data) => {
                                            txtAttestationTypeID.setValue(Number(data.id))
                                            txtAttestationType.setValue(data.name)
                                        }}>{getInputButton('select')}</DictSelectorContainer>
                                    }  
                                />
                            </Flex>

                            <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.qualification ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Квалификация <p className='pulse'></p></Flex>
                                <Input placeholder="Квалификация" {...txtQualification}
                                    suffix={txtQualification.value && <Button size="sm" variant="iconInput" onClick={() => txtQualification.setValue('')}><IconClearClose width='18px' height='18px' /></Button>}
                                />
                            </Flex>
                        </Flex>
                        <Button width='100%' onClick={handleBtnSave}>Применить изменения</Button>
                    </Flex>
                </Container>
            </Flex>
        </Modal>
    </>
}